import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'member';

const initialState = {
    data: {},
    change: {}
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setChange(state, action) {
            state.change = json.toJSON(action.payload);
        }
    }
});

export const { setData, setChange } = slice.actions;

export const selectData = state => json.fromJSON(state[name].data);
export const selectChange = state => json.fromJSON(state[name].change);

const memberReducer = slice.reducer;
export default memberReducer;